import { render, staticRenderFns } from "./ContactsLinkMobile.vue?vue&type=template&id=456d052a"
import script from "./ContactsLinkMobile.vue?vue&type=script&lang=js"
export * from "./ContactsLinkMobile.vue?vue&type=script&lang=js"
import style0 from "./ContactsLinkMobile.vue?vue&type=style&index=0&id=456d052a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports